import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "sending-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" Заказ отправляется... "),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "lds-dual-ring" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "Заказ оформлен", -1)
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderingForm = _resolveComponent("OrderingForm")!
  const _component_EmptyBasket = _resolveComponent("EmptyBasket")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.basketCost)
      ? (_openBlock(), _createBlock(_component_OrderingForm, { key: 0 }))
      : (_ctx.sendingOrderNow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : (Object.keys(_ctx.receivedOrderDataFromApi).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h3", null, [
                _createElementVNode("div", null, "Номер заказа: #" + _toDisplayString(_ctx.receivedOrderDataFromApi.id), 1),
                _createElementVNode("div", null, "Время создания заказа: " + _toDisplayString(_ctx.createdTimeToString()), 1),
                _createElementVNode("div", null, "Время выполнения заказа: " + _toDisplayString(_ctx.deliveryTimeToString()), 1),
                (_ctx.receivedOrderDataFromApi.address.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Адрес: " + _toDisplayString(_ctx.receivedOrderDataFromApi.address), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, "Сумма заказа: " + _toDisplayString(_ctx.receivedOrderDataFromApi.price) + "₽", 1)
              ])
            ]))
          : (_openBlock(), _createBlock(_component_EmptyBasket, { key: 3 }))
  ]))
}